// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__PT_Serif_14e21f', '__PT_Serif_Fallback_14e21f'","fontStyle":"normal"},"className":"__className_14e21f","variable":"__variable_14e21f"};